export var ErrorMessageKey;
(function (ErrorMessageKey) {
    ErrorMessageKey["noBlankMsg"] = "noBlankMsg";
    ErrorMessageKey["noLettersMsg"] = "noLettersMsg";
    ErrorMessageKey["noNumbersMsg"] = "noNumbersMsg";
    ErrorMessageKey["noSpacesMsg"] = "noSpacesMsg";
    ErrorMessageKey["noSpecialCharactersMsg"] = "noSpecialCharactersMsg";
    ErrorMessageKey["tooShortFourMsg"] = "tooShortFourMsg";
    ErrorMessageKey["tooLongTwentyEightMsg"] = "tooLongTwentyEightMsg";
    ErrorMessageKey["tooShortEightMsg"] = "tooShortEightMsg";
    ErrorMessageKey["tooLongThirtyTwoMsg"] = "tooLongThirtyTwoMsg";
    ErrorMessageKey["usernameTakenMsg"] = "usernameTakenMsg";
    ErrorMessageKey["noSpecialCharactersGrepMsg"] = "noSpecialCharactersGrepMsg";
    ErrorMessageKey["tooLongTwentyMsg"] = "tooLongTwentyMsg";
    ErrorMessageKey["noPasswordMatchMsg"] = "noPasswordMatchMsg";
    ErrorMessageKey["noPasswordUsernameMatchMsg"] = "noPasswordUsernameMatchMsg";
})(ErrorMessageKey || (ErrorMessageKey = {}));
export var getErrorMessage = function (key, fieldName) {
    var errors = {
        noBlankMsg: "Enter a ".concat(fieldName, " to continue."),
        noLettersMsg: "Your ".concat(fieldName, " must contain at least 1 letter."),
        noNumbersMsg: "Your ".concat(fieldName, " must contain at least 1 number."),
        noSpacesMsg: "Your ".concat(fieldName, " can\u2019t contain spaces."),
        noSpecialCharactersMsg: "Your ".concat(fieldName, " can\u2019t contain emoji or foreign language characters, or special characters like ^ * ( ) |"),
        tooShortFourMsg: "Your ".concat(fieldName, " must contain at least 4 characters."),
        tooLongTwentyEightMsg: "Your ".concat(fieldName, " can\u2019t contain more than 28 characters."),
        usernameTakenMsg: 'This username is taken. Try again.',
        tooShortEightMsg: "Your ".concat(fieldName, " must contain at least 8 characters."),
        tooLongThirtyTwoMsg: "Your ".concat(fieldName, " can\u2019t contain more than 32 characters."),
        noSpecialCharactersGrepMsg: "Your ".concat(fieldName, " can\u2019t contain emoji, foreign language characters, or the special character |"),
        tooLongTwentyMsg: "Your ".concat(fieldName, " can\u2019t contain more than 20 characters."),
        noPasswordUsernameMatchMsg: "Your ".concat(fieldName, " can\u2019t be the same as your username."),
        noPasswordMatchMsg: "Your ".concat(fieldName, " can\u2019t contain your password."),
    };
    return errors[key];
};
//# sourceMappingURL=formFieldErrors.js.map